module.exports = __webpack_public_path__ + "static/media/ESG.c807f3aa.svg";